import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classNames(classes.description, classes.textCenter)}>
            Broker, connecting investors and sellers
          </h2>
          <h3>Buy, negotiate, sell, invest, grow, Winning</h3>
          <h5>
            Kinos is always looking for opportunities for investors.
We have big portfolio include single asset repositioning, corporate divestitures, joint venture programs, entity investments, development opportunities and debt deals. Assets may be acquired either individually or in portfolio transactions.
          </h5>
          <h5>Please if you want to make some investment as a buyer or  as a seller your want to sale, please send us your criteria investment  or information of your assets.  </h5>
          <h5>We specialize in the marketing of real estate assets. We work with the latest technology in asset management, databases and marketign online. If you want to sell an asset from a home to all kinds of corporate real estate assets.
Quality management applied to the sales process, professional service with detailed reporting and monitoring of each operation. </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
